let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iHR24")).then(() => parcelRequire('5Y1MC'));